`
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>

    <v-expansion-panels
      v-if="hasFilters()"
      class="mb-3 elevation-1"
      focusable
    >
      <v-expansion-panel>
        <v-expansion-panel-header>
          Filters
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-4">
            <template v-for="(filter, key) in filters">
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-if="filter.type === 'text'"
                  :label="filter.label"
                  v-model="filters[key].value"
                  outlined
                  dense
                  clearable
                  hide-details
                />
              </v-col>
            </template>

            <v-col cols="12" class="pb-0">
              <v-btn
                @click="fetchData()"
                outlined
                rounded
                color="primary"
              >
                Search
              </v-btn>
            </v-col>

          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>


    <v-data-table
      :headers="headers"
      :items="computedItems"
      :options="options"
      :loading="loading"
      loading-text="Loading..."
      :single-expand="true"
      :expanded.sync="expanded"
      class="elevation-1"
      hide-default-footer
      :show-expand="showExpand"
    >
      <!-- Default Loading wont display properly with the "body" slot defined -->
      <template v-if="!loading" v-slot:body="props">
        <!--
         Important: There is an issue with the reactivity of the props when using the
         generated stripe states. Unsure why it doesnt update. For now we pass the items directly to our child
         slot using the computed method (rather than deconstructing it from props).
        -->
        <slot
          name="body"
          v-bind="{ items: computedItems }"
        />
      </template>

      <template v-slot:footer="{}">
        <v-divider/>
        <v-layout>
          <span/>
          <v-spacer/>
          <v-btn
            icon
            :disabled="loading || disabledPrev"
            @click="previous"
          >
            <v-icon>navigate_before</v-icon>
          </v-btn>
          <v-btn
            icon
            :disabled="loading || disabledNext"
            @click="next"
          >
            <v-icon>navigate_next</v-icon>
          </v-btn>
        </v-layout>
      </template>
    </v-data-table>
  </div>

</template>
<script>
import { isEmpty } from 'lodash'

export default {
  name: 'BaseStripeTable',
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    fetchAction: {
      type: String,
      default: ''
    },
    fetchQuery: {
      type: Object,
      default: () => ({})
    },
    fetchHeaders: {
      type: Object,
      default: () => ({})
    },
    itemsGetter: {
      type: String,
      default: 'test'
    },
    paginationGetter: {
      type: String,
      default: ''
    },
    showExpand: {
      type: Boolean,
      default: false
    },
    filterOptions: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      expanded: [],
      disabledPrev: false,
      disabledNext: false,
      loading: false,
      query: this.$route.query,
      filters: {}
    }
  },
  computed: {
    options() {
      const pagination = this.$store.getters[ this.paginationGetter ]
      return {
        itemsPerPage: pagination.limit
      }
    },
    computedItems() {
      return this.loading
        ? []
        : this.$store.getters[ this.itemsGetter ]
    }
  },
  watch: {
    '$route.query': function () {
      this.fetchData()
    }
  },
  created() {
    this.filters = { ...this.filterOptions }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    hasFilters() {
      return !isEmpty(this.filters)
    },
    getFiltersPayload() {
      const payload = {}
      for (const [ key, data ] of Object.entries(this.filters)) {
        if (!isEmpty(data.value)) {
          payload[ key ] = data.value
        }
      }

      return payload
    },
    fetchData(type) {
      this.loading = true
      const query = this.fetchQuery || this.$route.query
      const payload = {
        type,
        query: {
          ...query,
          ...this.getFiltersPayload()
        },
        _headers: { ...this.fetchHeaders }
      }

      this.$store.dispatch(this.fetchAction, payload)
        .finally(() => {
          // !!! IMPORTANT !!! loading must stop first. Computed functions depend on it.
          this.loading = false

          const pagination = this.$store.getters[ this.paginationGetter ]
          const { limit, has_more } = pagination

          this.disabledPrev = (type === 'prev' && has_more === false) || type === undefined
          this.disabledNext = type === 'next' && has_more === false

          // Disable both if the result set is less than the pagination limit
          const hasNoItems = this.computedItems.length === 0
          // We CANNOT use <= here because that's what the has_more boolean is for
          const lessThanLimit = this.computedItems.length < limit

          if (hasNoItems || lessThanLimit) {
            this.disabledPrev = true
            this.disabledNext = true
          }
        })
    },
    previous() {
      this.fetchData('prev')
    },
    next() {
      this.fetchData('next')
    },
  }
}
</script>
